"use client";

import { Stack, Avatar, Typography, Link } from "@mui/material";

interface CertificationBadgeProps {
  image: string;
  title: string;
  onClick?: () => void;
}

export function CertificationBadge({ 
  image, 
  title,
  onClick,
}: CertificationBadgeProps) {
  return (
    <Stack spacing={2.75} alignItems="center">
      <Avatar
        src={image}
        alt={title}
        sx={{
          width: 160,
          height: 160,
          border: "none",
        }}
      />
      <Stack spacing={0.5} alignItems="center">
        <Typography
          sx={{
            fontFamily: "'Noto Sans Thai', sans-serif",
            fontSize: 18,
            fontWeight: 400,
            lineHeight: "26px",
            color: "#ffffff",
            textAlign: "center",
          }}
        >
          {title}
        </Typography>
        <Link
          onClick={onClick}
          sx={{
            fontFamily: "'Noto Sans Thai', sans-serif",
            fontSize: 14,
            fontWeight: 400,
            color: "#ffffff",
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          ดูเอกสาร
        </Link>
      </Stack>
    </Stack>
  );
}